const DEFAULT_DATA = () => ({
  id: "",
  name: "",
  abbreviation: "",
  description: "",
  superintendenceUnity: [],
  areas: [],
  responsables: [],
  updateTime: "",
  category: [],
  subcategory: [],
  cisba_categories: [],
  category_id_table: "",
  cisba_categories_table: [],
});

export default {
  state: {
    cisbaBiSystemsData: DEFAULT_DATA(),
    infoTableCisbaBi: DEFAULT_DATA(),
  },

  getters: {
    getCisbaBiSystemsData(state) {
      return state.cisbaBiSystemsData;
    },

    getInfoTableCisbaBi(state) {
      return state.infoTableCisbaBi;
    },
  },

  mutations: {
    setCisbaBiSystemsData(state, data) {
      if (data === null) {
        return (state.cisbaBiSystemsData = DEFAULT_DATA());
      }

      const isEdit = data.cisba_categories?.length > 0;

      state.cisbaBiSystemsData = {
        category_id: parseInt(data.category_id),
        cisba_categories: data.cisba_categories?.flatMap((cat) => {
          if (!cat) return []; // Ignora null/undefined
          const { id, cisba_sub_categories } = cat;
          return [
            {
              id,
              subcategory_ids:
                cisba_sub_categories
                  ?.filter((sub) => sub != null) // Remove null/undefined
                  .map(({ id }) => id) ?? [],
            },
          ];
        }),
        isEdit,
      };
    },

    setInfoTableCisbaBi(state, data) {
      if (data === null) {
        return (state.infoTableCisbaBi = DEFAULT_DATA());
      }

      state.infoTableCisbaBi = {
        cisba_categories_table:
          data.cisba_categories?.flatMap((cat) => {
            if (!cat) return [];

            const { id, name, cisba_sub_categories } = cat;

            // Garante que cisba_sub_categories seja sempre um array
            const validSubs = Array.isArray(cisba_sub_categories)
              ? cisba_sub_categories.filter((sub) => sub != null)
              : [];

            // Se não houver subcategorias válidas (ou só tiver null), mostra a categoria com subcategoria vazia
            if (validSubs.length === 0) {
              return [
                {
                  category: name,
                  category_id_table: id,
                  subcategory: null,
                  subcategory_ids_table: null,
                },
              ];
            }

            // Caso tenha subcategorias válidas, cria uma linha separada para cada uma
            return validSubs.map((sub) => ({
              category: name,
              category_id_table: id,
              subcategory: sub.name ?? null,
              subcategory_ids_table: sub.id ?? null,
            }));
          }) ?? [],
      };
    },
  },

  actions: {
    changeCisbaBiSystemsData(context, infos) {
      context.commit("setCisbaBiSystemsData", infos);
    },

    changeInfoTableCisbaBi(context, infos) {
      context.commit("setInfoTableCisbaBi", infos);
    },
  },
};
